import * as Icons from 'react-bootstrap-icons';

// Ezek a menüpontok nem a beúszó menübe, hanem közvetlenül a fejlécbe kerülnek.
export const DIRECT_MENU_CODES = ['home', 'events', 'tudasbazis', 'dashboard'];

// Kliens-oldali felirat-felülbírálás (DB-módosítás nélkül) — ld. griff skill "Nyitott kérdések".
export const LABEL_OVERRIDES = {
    events: 'Hírek',
};

// A beúszó menü csoportosítása funkcionalitás szerint. Bármely MenuCode, ami
// egyik listában sincs (és nem DIRECT_MENU_CODES tagja), az "Egyéb" csoportba
// esik — így egy jövőben felvett új menüpont sosem tűnik el nyomtalanul.
export const GROUPS = [
    {
        key: 'masterdata',
        label: 'Törzsadatok',
        icon: 'database',
        codes: ['organisations', 'persons', 'abilities', 'exercises', 'groups', 'properties'],
    },
    {
        key: 'training',
        label: 'Edzés',
        icon: 'kanban',
        codes: ['traininghead', 'task_work', 'events-admin', 'trainingplan', 'session_templates'],
    },
    {
        key: 'results',
        label: 'Eredmény / Pénzügy',
        icon: 'trophy',
        codes: ['allresults', 'paymentforms'],
    },
    {
        key: 'admin',
        label: 'Adminisztráció',
        icon: 'shield-lock-fill',
        codes: ['permissions', 'statistics'],
    },
];

const OTHER_GROUP = { key: 'other', label: 'Egyéb', icon: 'three-dots' };

// A menuItems (DB MenuItems/MenuLevelDefaults) csak bejelentkezés után töltődik
// be (ld. AuthContext.js loadMenuItems) — kijelentkezett állapotban `menuItems`
// üres tömb. Enélkül a tartalék lista nélkül a nem-auth-os tételek (Kezdőlap,
// Hírek) sem jelennének meg kijelentkezve. A griffnavbar.js régi
// fallbackMenuItems-éből átemelve.
const FALLBACK_MENU_ITEMS = [
    { MenuCode: 'home', MenuPath: '/home', MenuName: 'Kezdőlap', MenuIcon: 'house-fill', RequireAuth: false, HasAccess: true, SortOrder: 1 },
    { MenuCode: 'events', MenuPath: '/esemenyek', MenuName: 'Események', MenuIcon: 'calendar-event-fill', RequireAuth: false, HasAccess: true, SortOrder: 2 },
    { MenuCode: 'tudasbazis', MenuPath: '/tudasbazis', MenuName: 'Tudás bázis', MenuIcon: 'book-fill', RequireAuth: false, HasAccess: true, SortOrder: 3 },
];

// A griffnavbar.js-ből átemelt szűrő/rendező logika — RequireAuth/HasAccess
// szerint szűr, SortOrder szerint rendez. Ez az egyetlen hely, ahol ez a
// szabály él (Header és Sidebar is ezt hívja).
export function getVisibleMenuItems(menuItems, loginState) {
    const isLoggedIn = loginState === 'LOGGEDIN';
    const effectiveItems = menuItems && menuItems.length > 0 ? menuItems : FALLBACK_MENU_ITEMS;
    return effectiveItems
        .filter((item) => {
            if (!item.RequireAuth) return true;
            return isLoggedIn && item.HasAccess;
        })
        .sort((a, b) => (a.SortOrder || 0) - (b.SortOrder || 0));
}

// A látható (már szűrt) menüpontokat szétosztja: fejléc-közvetlen linkek,
// csoportosított sidebar-tételek, és a fenti csoportokba nem eső "Egyéb" tételek.
export function splitMenuItems(visibleItems) {
    const direct = [];
    const byCode = new Map();
    visibleItems.forEach((item) => {
        if (DIRECT_MENU_CODES.includes(item.MenuCode)) {
            direct.push(item);
        } else {
            byCode.set(item.MenuCode, item);
        }
    });

    const groups = GROUPS.map((group) => ({
        ...group,
        items: group.codes.map((code) => byCode.get(code)).filter(Boolean),
    })).filter((group) => group.items.length > 0);

    const usedCodes = new Set(GROUPS.flatMap((g) => g.codes));
    const otherItems = visibleItems.filter(
        (item) => !DIRECT_MENU_CODES.includes(item.MenuCode) && !usedCodes.has(item.MenuCode)
    );
    if (otherItems.length > 0) {
        groups.push({ ...OTHER_GROUP, items: otherItems });
    }

    return { direct, groups };
}

export function getMenuLabel(item) {
    return LABEL_OVERRIDES[item.MenuCode] || item.MenuName;
}

// Kebab-case ikonnév (DB MenuIcon mező) -> react-bootstrap-icons PascalCase
// komponensnév. A pageDashboard.js-ből kiemelt minta, hogy ne duplikálódjon.
export function getMenuIcon(iconName, size = 20) {
    if (!iconName) return <Icons.QuestionCircle size={size} />;

    const componentName = iconName
        .split('-')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');

    const IconComponent = Icons[componentName];
    return IconComponent ? <IconComponent size={size} /> : <Icons.QuestionCircle size={size} />;
}
